module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.75c59caa.svg";